import { render, staticRenderFns } from "./GoodAtrr.vue?vue&type=template&id=004e701a&"
import script from "./GoodAtrr.vue?vue&type=script&lang=js&"
export * from "./GoodAtrr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports